(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SGPUI", [], factory);
	else if(typeof exports === 'object')
		exports["SGPUI"] = factory();
	else
		root["SGPUI"] = factory();
})(self, () => {
return 